export const latestVersion = {
  versao: '1.20.2',
  data: '2025-06-27',
  tipo: 'Release',
  branch: 'Release/TAS-464',
  titulo: 'Novo componente de versão',
  descricao: 'Componente de detalhamento de versão da plataforma ONFARM.',
  mudancas: [
    {
      titulo: 'FRONT-END',
      detalhe:
        'Para facilitar a visualização e o controle das versões, foi criado um novo componente de detalhamento de versão. Agora é possível visualizar informações detalhadas sobre cada versão da plataforma.',
    },
  ],
};

export const changelogData = [
  latestVersion,

  {
    versao: '1.20.1',
    data: '2025-06-27',
    tipo: 'Release',
    branch: 'Release/TAS-462',
    titulo: 'Adição de nova opção',
    descricao: 'Nova opção para registro de laudos.',
    mudancas: [
      {
        titulo: 'FRONT-END',
        detalhe:
          'No módulo de laudos, em novo laudo, no campo meios de cultura foi incluido a opção Solufarm Capt, solicitação realizada pela área de qualidade.',
      },
    ],
  },
];
